import { Injectable } from '@angular/core';
import {environment} from '../../../environments/environment';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Company, GetParams, GetResponse, PostResponse, UserCompany} from '@app/shared';
import {BehaviorSubject, Observable} from 'rxjs';
import {convertGetParamsToHttpParams} from '../utils/api-utils';

@Injectable({
  providedIn: 'root'
})
export class CompanyService {

  selectedCompanyId$: BehaviorSubject<number | undefined> = new BehaviorSubject<number | undefined>(undefined);

  /** URLs principales relacionadas con Company **/
  companyUrl = environment.identityApiBaseUrl + '/api/company';
  userCompanyUrl = environment.identityApiBaseUrl + '/api/user-company';

  constructor(private http: HttpClient) { }

  get selectedCompanyId(): Observable<number | undefined> {
    return this.selectedCompanyId$ as Observable<number | undefined>
  }

  set selectedCompanyId(value: number) {
    this.selectedCompanyId$.next(value);
  }

  /** Metodos de obtener/crear/actualizar/eliminar Company **/
  getCompany(getParams: GetParams): Observable<GetResponse> {
    return this.http.get<GetResponse>(this.companyUrl, {params: convertGetParamsToHttpParams(getParams)});
  }

  createCompany(newCompany: any): Observable<PostResponse> {
    return this.http.post<PostResponse>(this.companyUrl, newCompany);
  }

  updateCompany(Company: Company): Observable<any> {
    return this.http.put(this.companyUrl, Company);
  }

  deleteCompany(ids: number[]): Observable<any> {
    return this.http.delete(this.companyUrl,  {body: {ids: ids}});
  }

  /** Metodos de obtener/crear/actualizar/eliminar UserCompany **/
  getUserCompany(getParams: GetParams): Observable<GetResponse> {
    return this.http.get<GetResponse>(this.userCompanyUrl, {params: convertGetParamsToHttpParams(getParams)});
  }

  createUserCompany(newUserCompany: {name: string, isActive: boolean}): Observable<PostResponse> {
    return this.http.post<PostResponse>(this.userCompanyUrl, newUserCompany);
  }

  updateUserCompany(UserCompany: UserCompany): Observable<any> {
    return this.http.put(this.userCompanyUrl, UserCompany);
  }

  deleteUserCompany(desconsolidationsTypeIds: number[]): Observable<any> {
    return this.http.delete(this.userCompanyUrl, {body: {ids: desconsolidationsTypeIds}});
  }

  public getCompanyHeaders(): HttpHeaders {
    const companyId = this.selectedCompanyId$.getValue();

    if (!companyId) {
      throw new Error('No company ID selected');
    }

    return new HttpHeaders({
      'companyId': companyId.toString(),
      'accept': 'application/json',
      'Content-Type': 'application/json',
    });
  }

}
